export default {"src":"/_next/static/media/gramax-logo-desktop-light.d6ffd7b9.svg","height":32,"width":86,"blurWidth":0,"blurHeight":0};